import appManager from 'AppManager';
import { t } from 'Locale';
import React from 'react';
import { Linking } from 'react-native';
import { AccountData, SubscriptionData } from './AccountInfo.types';

// This return type should be right but eslint (ts) does not accept it
const fotmatAccountInfo = (userData: AccountData): Array<{ text: string; title: string }> =>
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignorets
    [
        !!userData.login && { text: userData.login, title: t('REGISTRATION.CREATE_ACC_NAME') },
        !!userData.email && { text: userData.email, title: t('REGISTRATION.CREATE_ACC_MAIL') },
        !!userData.accountId && { text: userData.accountId, title: t('DEVICE_INFO.DEVICE_ID') }
    ].filter(Boolean);

// This return type should be right but eslint (ts) does not accept it
const formatSubcriptionInfo = (
    userSubcriptionData: SubscriptionData
): Array<{ title: string; description: string | Array<string> }> =>
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignorets
    [
        userSubcriptionData.plans.length > 0 && {
            title: t('SUBSCRIPTION.OPTION_RATEPLAN'),
            description: userSubcriptionData.plans.map((subPlan, index) =>
                index === 0 ? `${subPlan}` : `, ${subPlan}`
            )
        },
        userSubcriptionData.packages.length > 0 && {
            title: t('SUBSCRIPTION.OPTION_PACKAGE'),
            description: userSubcriptionData.packages.map((item, index) =>
                index === 0 ? `${item}` : `, ${item}`
            )
        },
        userSubcriptionData.addons.length > 0 &&
            userSubcriptionData.addons.map(
                (item) => item && { title: t('SUBSCRIPTION.OPTION_ADDON'), description: item }
            ),
        {
            title: t('SUBSCRIPTION.OPTION_RENEWS'),
            description: `${userSubcriptionData.paidTo.slice(
                8,
                10
            )}.${userSubcriptionData.paidTo.slice(5, 7)}.${userSubcriptionData.paidTo.slice(0, 4)}`
        }
    ]
        .flat(1)
        .filter(Boolean);

export const getAccountInfo = (
    userData: AccountData
): Array<{ title: string; data: Array<{ text: string; title: string }> }> => [
    {
        title: t('COMMON.ACCOUNT_INFO_MOBILES').toUpperCase(),
        data: fotmatAccountInfo(userData)
    }
];
export const fetchSubcriptionInfo = async (
    setUserSubcriptionData: React.Dispatch<React.SetStateAction<SubscriptionData | null>>,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>
): Promise<void> => {
    try {
        const subcriptionInfoData: { subscription: SubscriptionData } =
            await appManager.api.getSubscriptionInfo();

        setUserSubcriptionData(subcriptionInfoData.subscription);
        setLoading(true);
    } catch (error) {
        setLoading(false);
        console.log(error);
    }
};

export const getSubcriptionInfo = (
    userSubcriptionData: SubscriptionData
): Array<{
    title: string;
    data: Array<{ description: string | Array<string>; title: string }>;
}> => [
    {
        title: t('SETTINGS.ACCOUNT_SETTINGS_MY_SUBSCRIPTION').toUpperCase(),
        data: formatSubcriptionInfo(userSubcriptionData)
    }
];

export const onButtonClick = async (): Promise<void> => {
    try {
        const urlLink = await appManager.api.manageSubscription();
        await Linking.openURL(urlLink.otvCode.url);
    } catch (err) {
        console.log(err);
    }
};
